import styled from "styled-components/macro";
import { Text } from "@gcs/design-system/react";

export const FactoryContainer = (({ theme }) => ({
    padding: "40px 16px",
    
    [theme.breakpoint.xl()]: {
        padding : "44px calc((100% - 1260px)/2) 64px"
    },

    "@media (min-width: 1200px) and (max-width: 1600px)": {
        padding: "44px 156px 64px 220px"
    },
}));

export const FactoryTitle = (({ theme }) => ({
    fontSize: "36px",
    fontWeight: "700",
    lineHeight: "150%",
    marginBottom: "32px",
    color: theme.color.brandPrimary.light,

    [theme.breakpoint.lg()]: {
        fontSize: "48px"
    }
}));

export const FactoryParagraph = (({ theme }) => ({
    fontSize: "18px",
    fontWeight: "500",
    lineHeight: "160%",
    marginBottom: "32px",

    [theme.breakpoint.lg()]: {
        fontSize: "20px"
    }
}))

export const Container = styled.section(({ theme }) => ({
    ...FactoryContainer({ theme })
}));

export const Title = styled(Text)( ({ theme }) => ({
    ...FactoryTitle({ theme })
}));

export const Paragraph = styled(Text)(({ theme }) => ({
    ...FactoryParagraph({ theme }),
    marginBottom: 0
}));